import LvFanEvent from './LvFanEvent';

const LvFanEventJa = () => {
    return (
        <LvFanEvent
            currentPath="/lv4-ja"
            // songGuideTitle="「HUSH」 掛け声（合唱）ガイド動画"
            sloganGuideTitle="フォトタイム スローガンガイド"
            eventImage="/fan-event-info-ja.png"
        />
    );
};

export default LvFanEventJa;
